import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/700.css';

import '@fontsource/inter/400.css';
import '@fontsource/inter/500.css';
import '@fontsource/inter/600.css';
import '@fontsource/inter/700.css';

import '@fontsource/poppins/400.css';
import '@fontsource/poppins/500.css';
import '@fontsource/poppins/600.css';
import '@fontsource/poppins/700.css';

import '@fontsource/public-sans/400.css';
import '@fontsource/public-sans/500.css';
import '@fontsource/public-sans/600.css';
import '@fontsource/public-sans/700.css';
import { ConfigProvider } from 'contexts/ConfigContext';

// Global CSS to prevent horizontal scroll
const globalStyle = document.createElement('style');
globalStyle.innerHTML = `
  * {
    box-sizing: border-box;
  }

  html, body {
    overflow-x: hidden;
    max-width: 100vw;
  }

  #root {
    overflow-x: hidden;
    max-width: 100vw;
  }

  /* Fix for Material-UI Container overflow */
  .MuiContainer-root {
    max-width: 100% !important;
    overflow-x: hidden;
  }

  /* Fix for Grid containers */
  .MuiGrid-container {
    width: 100% !important;
    max-width: 100% !important;
  }

  /* Fix for any element that might cause horizontal scroll */
  .MuiBox-root,
  .MuiCard-root,
  .MuiPaper-root {
    max-width: 100%;
  }
`;
document.head.appendChild(globalStyle);

const root = ReactDOM.createRoot(document.getElementById('root'));

// ==============================|| MAIN - REACT DOM RENDER ||============================== //

root.render(
  <ConfigProvider>
    <App />
  </ConfigProvider>
);
